var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2475 16.1481L16.9275 14.4681C17.1538 14.2446 17.44 14.0917 17.7516 14.0278C18.0631 13.9639 18.3865 13.9918 18.6825 14.1081L20.73 14.9256C21.0291 15.047 21.2856 15.2543 21.4671 15.5212C21.6486 15.7881 21.747 16.1028 21.75 16.4256V20.1756C21.7482 20.3952 21.7021 20.6122 21.6143 20.8134C21.5265 21.0147 21.3989 21.1961 21.2391 21.3468C21.0793 21.4974 20.8907 21.6142 20.6847 21.6901C20.4786 21.7659 20.2593 21.7993 20.04 21.7881C5.69248 20.8956 2.79748 8.74562 2.24998 4.09562C2.22456 3.86727 2.24778 3.63613 2.31811 3.4174C2.38844 3.19867 2.50429 2.99731 2.65803 2.82657C2.81177 2.65583 2.99992 2.51957 3.2101 2.42676C3.42028 2.33396 3.64772 2.28671 3.87748 2.28812H7.49998C7.82324 2.28907 8.13881 2.38672 8.40612 2.56849C8.67344 2.75026 8.88025 3.00785 8.99998 3.30812L9.81748 5.35562C9.93767 5.65042 9.96833 5.9741 9.90564 6.28623C9.84295 6.59835 9.68968 6.88509 9.46498 7.11062L7.78498 8.79062C7.78498 8.79062 8.75248 15.3381 15.2475 16.1481Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.24879b4210b8eee18f3c0c3013bdc366.svg";
export { ForwardRef as ReactComponent };